/* src/app/modules/dna-syngovia/components/dna-syngovia-comparison-board/dna-syngovia-comparison-board.component.scss */
:host {
  display: block;
  height: calc(100% - var(--sh-modal-wrapper-content-margin-bottom));
}
.cards-container {
  display: flex;
  flex-wrap: nowrap;
  gap: 1rem;
  width: 100%;
  height: 100%;
  overflow-x: auto;
}
/*# sourceMappingURL=dna-syngovia-comparison-board.component.css.map */
